import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import {
  MODEL_FEE,
  MODEL_FEE_DETAIL,
  MODEL_ITEM,
  MODEL_FREIGHT_ITEM,
  MODEL_ORDERINFOMATION,
  MODEL_PIN,
} from '@/lib/outbound/useQuick';
import { MODEL_PAYMENT } from '@/lib/outbound/usePayment';
import { modelRequiredQuick } from '@/models/outbounds/requiredQuick';

export class QuickState {
  // 결제정보
  public payment: outbound.payment = MODEL_PAYMENT();
  // 결제 해야 할 목록
  public paymentList: outbound.quick.package[] = [];
  // 주문 작성 완료 목록
  public completeList: outbound.quick.package[] = [];

  /**
   *  현재 작성중인 주문
   */
  public packageOrigin: outbound.pin = MODEL_PIN();
  public packageDestination: outbound.pin = MODEL_PIN();
  public packageItem: outbound.quick.item = MODEL_ITEM();
  public packageFreightItem: outbound.quick.freightItem = MODEL_FREIGHT_ITEM();
  public packageFee: outbound.quick.fee = MODEL_FEE();
  public packageFeeDetail: outbound.quick.feeDetail = MODEL_FEE_DETAIL();
  public packageOrderInfomation: outbound.quick.orderInfomation = MODEL_ORDERINFOMATION();
  public validatePopup: boolean = false; //현재 주문 필수 입력항목 팝업
  public quickType: 'bike' | 'freight' = 'bike'; // 퀵 - 오토바이 / 화물 현재작성중인 탭
  public canUsePayment: boolean = false; //결제모달 오픈가능 여부

  //유효성 검증 여부만 boolean으로 확인
  public validationInfo: required.quick = new modelRequiredQuick();

  public centerOrderTimes: api.center.serviceState.timeType[] = [];
  public anywhereOrderTimes: api.center.serviceState.timeType[] = [];

  public customerDropOffMethod: outbound.itemDeliveryMethod = '';
  public onsitePickupRequestedAt?: string;
  public onsitePickupClientComment?: string;

  public quickReserveHourOvertime?: boolean = false;
  public quickReserveCenterOvertime?: boolean = false;

  public nowIspickupReserveOvertime?: boolean = false;
  public nowIspickupServiceOvertime?: boolean = false;
  public blankPickupReserveTime?: boolean = false;
  public pickupServiceTimes: api.center.serviceState.timeType[] = [];
  public pickupServiceAvailable: boolean = false;
}

const Mutations: MutationTree<QuickState> = {
  /**
   * 현재 작성중인 주문 목록 업데이트
   */
  updatePackageOrigin(state: QuickState, payload: vuex.outbound.updateData<outbound.pin>) {
    state.packageOrigin[payload.key] = payload.value;
  },
  updatePackageDestination(state: QuickState, payload: vuex.outbound.updateData<outbound.pin>) {
    state.packageDestination[payload.key] = payload.value;
  },
  updatePackageItem(state: QuickState, payload: vuex.outbound.updateData<outbound.quick.item>) {
    state.packageItem[payload.key] = payload.value;
  },
  updatePackageFreightItem(state: QuickState, payload: vuex.outbound.updateData<outbound.quick.freightItem>) {
    state.packageFreightItem[payload.key] = payload.value;
  },
  updatePackageFee(state: QuickState, payload: vuex.outbound.updateData<outbound.quick.fee>) {
    state.packageFee[payload.key] = payload.value;
  },
  updatePackageFeeDetail(state: QuickState, payload: vuex.outbound.updateData<outbound.quick.feeDetail>) {
    state.packageFeeDetail[payload.key] = payload.value;
  },
  updatePackageOrderInfomation(state: QuickState, payload: vuex.outbound.updateData<outbound.quick.orderInfomation>) {
    state.packageOrderInfomation[payload.key] = payload.value;
  },

  /**
   * completeList(주문완료 목록) 변경
   */
  updateCompleteList(state: QuickState, payload: outbound.quick.package[]) {
    state.completeList = [...payload];
  },

  /**
   * paymentList(결제 목록) 변경
   */
  updatePaymentList(state: QuickState, payload: outbound.quick.package[]) {
    state.paymentList = [...payload];
  },

  /**
   *  payment(결제정보) 변경
   */
  updatePayment(state: QuickState, payload: vuex.outbound.updateData<outbound.payment>) {
    state.payment[payload.key] = payload.value;
  },

  updateValidateInfo(state: QuickState, payload: required.quick) {
    state.validationInfo = payload;
  },

  resetValidateInfo(state: QuickState, payload: required.quick) {
    state.validationInfo = payload;
  },

  resetValidateDeliveryMethod(state: QuickState, payload: outbound.itemDeliveryMethod) {
    state.validationInfo.customerDropOffMethod = false;
    state.validationInfo.nowIspickupReserveOvertime = false;
    state.validationInfo.blankPickupReserveTime = false;
    state.validationInfo.nowIspickupServiceOvertime = false;
  },

  //센터접수가능시간 업데이트
  updateCenterOrderTimes(state: QuickState, payload: api.center.serviceState.timeType[]) {
    state.centerOrderTimes = payload;
  },

  //직접접수가능시간 업데이트
  updateAnywhereOrderTimes(state: QuickState, payload: api.center.serviceState.timeType[]) {
    state.anywhereOrderTimes = payload;
  },

  //구내픽업가능시간 업데이트
  updatePickupServiceTimes(state: QuickState, payload: api.center.serviceState.timeType[]) {
    state.pickupServiceTimes = payload;
  },
  //구내픽업서비스 - 사용여부(토글 ON/OFF) / 카테고리별 사용여부(체크박스)
  updatePickupServiceAvailable(state: QuickState, payload: boolean) {
    state.pickupServiceAvailable = payload;
  },

  updateQuickReserveHourOvertime(state: QuickState, payload: boolean) {
    state.quickReserveHourOvertime = payload;
  },
  updateQuickReserveCenterOvertime(state: QuickState, payload: boolean) {
    state.quickReserveCenterOvertime = payload;
  },

  updateBlankPickupReserveTime(state: QuickState, payload: boolean) {
    state.blankPickupReserveTime = payload;
  },

  //결제모달오픈 여부 업데이트
  updateCanUsePayment(state: QuickState, payload: boolean) {
    state.canUsePayment = payload;
  },
};

const Actions: ActionTree<QuickState, any> = {
  /**
   * 현재 작성중인 주문 목록 업데이트
   */
  updatePackageOrigin({ commit }, payload: vuex.outbound.updateData<outbound.pin>) {
    commit('updatePackageOrigin', payload);
  },
  updatePackageDestination({ commit }, payload: vuex.outbound.updateData<outbound.pin>) {
    commit('updatePackageDestination', payload);
  },
  updatePackageItem({ commit }, payload: vuex.outbound.updateData<outbound.quick.item>) {
    commit('updatePackageItem', payload);
  },
  updatePackageFreightItem({ commit }, payload: vuex.outbound.updateData<outbound.quick.item>) {
    commit('updatePackageFreightItem', payload);
  },
  updatePackageFee({ commit }, payload: vuex.outbound.updateData<outbound.quick.fee>) {
    commit('updatePackageFee', payload);
  },
  updatePackageFeeDetail({ commit }, payload: vuex.outbound.updateData<outbound.quick.feeDetail>) {
    commit('updatePackageFeeDetail', payload);
  },
  updatePackageOrderInfomation({ commit }, payload: vuex.outbound.updateData<outbound.quick.orderInfomation>) {
    commit('updatePackageOrderInfomation', payload);
  },

  /**
   * completeList(주문완료 목록) 변경
   */
  updateCompleteList({ commit }, payload: outbound.quick.package[]) {
    commit('updateCompleteList', payload);
  },

  /**
   * paymentList(결제 목록) 변경
   */
  updatePaymentList({ commit }, payload: outbound.quick.package[]) {
    commit('updatePaymentList', payload);
  },

  /**
   *  payment(결제정보) 변경
   */
  updatePayment({ commit }, payload: vuex.outbound.updateData<outbound.payment>) {
    commit('updatePayment', payload);
  },

  updateValidateInfo({ commit }, payload: required.quick) {
    commit('updateValidateInfo', payload);
  },

  resetValidateInfo({ commit }) {
    commit('resetValidateInfo', new modelRequiredQuick());
  },

  updateCenterOrderTimes({ commit }, payload: api.center.serviceState.timeType[]) {
    commit('updateCenterOrderTimes', payload);
  },

  updateAnywhereOrderTimes({ commit }, payload: api.center.serviceState.timeType[]) {
    commit('updateAnywhereOrderTimes', payload);
  },

  updatePickupServiceTimes({ commit }, payload: api.center.serviceState.timeType[]) {
    commit('updatePickupServiceTimes', payload);
  },
  updatePickupServiceAvailable({ commit }, payload: boolean) {
    commit('updatePickupServiceAvailable', payload);
  },

  updateQuickReserveHourOvertime({ commit }, payload: boolean) {
    commit('updateQuickReserveHourOvertime', payload);
  },
  updateQuickReserveCenterOvertime({ commit }, payload: boolean) {
    commit('updateQuickReserveCenterOvertime', payload);
  },
  updateBlankPickupReserveTime({ commit }, payload: boolean) {
    commit('updateBlankPickupReserveTime', payload);
  },
  resetValidateDeliveryMethod({ commit }, payload: boolean) {
    commit('resetValidateDeliveryMethod', payload);
  },

  updateCanUsePayment({ commit }, payload: boolean) {
    commit('updateCanUsePayment', payload);
  },
};
const Getters: GetterTree<QuickState, any> = {
  getValidateInfo: (state: QuickState) => (): required.quick => {
    return state.validationInfo;
  },
  getCenterOrderTimes: (state: QuickState) => (): api.center.serviceState.timeType[] => {
    return state.centerOrderTimes;
  },
  getAnywhereOrderTimes: (state: QuickState) => (): api.center.serviceState.timeType[] => {
    return state.anywhereOrderTimes;
  },
  getPickupServiceTimes: (state: QuickState) => (): api.center.serviceState.timeType[] => {
    return state.pickupServiceTimes;
  },
  getPickupServiceAvailable: (state: QuickState) => (): boolean => {
    return state.pickupServiceAvailable;
  },
  getQuickReserveHourOvertime: (state: QuickState) => (): boolean => {
    return state.quickReserveHourOvertime ?? false;
  },
  getQuickReserveCenterOvertime: (state: QuickState) => (): boolean => {
    return state.quickReserveCenterOvertime ?? false;
  },
  getBlankPickupReserveTime: (state: QuickState) => (): boolean => {
    return state.blankPickupReserveTime ?? false;
  },
};

const module: Module<QuickState, any> = {
  namespaced: true,
  state: new QuickState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
